// * Import 3rd party
import Autocomplete from "@mui/material/Autocomplete";
import { styled } from "@mui/material/styles";

const StyledAutoComplete = styled(
  Autocomplete,
  {}
)(({ theme, customProps }) => ({
  // height: "2em !important",
  // width: "100%",
  // borderRadius: theme.size[4],
  // "& .MuiFilledInput-root-notchedOutline": {
  //   borderColor: "transparent !important",
  // },
  "& .MuiFilledInput-root": {
    // height: theme.size[50],
    backgroundColor: theme.palette.form.fieldBackground,
    paddingTop: "0px",
    fontSize: theme.size[13],
    color: theme.palette.form.text,
    // borderBottom: "0px !important",
    "&:before, &:after": {
      borderBottom: "0px !important",
    },
  },
}));

export default StyledAutoComplete;
